// extracted by mini-css-extract-plugin
module.exports = {"label":"SportMenu_label__tWuJ7","menuWithHighlight":"SportMenu_menuWithHighlight__Iac37","loading":"SportMenu_loading__JiQ0w","loading-small":"SportMenu_loading-small___tcuN"};